import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]

import { RouteLocationRaw } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalMenuItem',
  props: {
    disabled: { type: Boolean },
    left: { type: Boolean },
    right: { type: Boolean },
    link: {},
    to: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_ctx.link)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: _ctx.link,
        target: "_blank",
        class: "modal-menu__item"
      }, [
        _renderSlot(_ctx.$slots, "default"),
        _renderSlot(_ctx.$slots, "icon", { iconClass: 'modal-menu__item-icon' })
      ], 8, _hoisted_1))
    : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.to ? 'router-link' : 'div'), {
        key: 1,
        to: _ctx.to,
        class: _normalizeClass(["modal-menu__item", {
      'justify-left': _ctx.left,
      'justify-right': _ctx.right,
      disabled: _ctx.disabled,
    }])
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default"),
          _renderSlot(_ctx.$slots, "icon", { iconClass: 'modal-menu__item-icon' })
        ]),
        _: 3
      }, 8, ["to", "class"]))
}
}

})